import { gql } from '@apollo/client'
import React from 'react'

import { templatesClient } from '../../../../utils/apollo/api'
import { useCurrentModal } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useTemplateState = () => React.useContext(Context)
export const useTemplate = () => useTemplateState()?.template

const QUERY = gql`
  query Template($id: ID) {
    template(id: $id) {
      id
      name
      enabled
      entity
      description
      documentId
      document {
        id
        src
        type
        caption
        updatedAt
        insertedAt
      }
      updatedAt
      insertedAt
    }
  }
`

const TemplateLoader = ({ children }) => {
  const { data: id } = useCurrentModal()
  const { data, ...state } = useQuery(QUERY, {
    skip: !id,
    variables: { id },
    client: templatesClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default TemplateLoader
